import { Box, CircularProgress } from '@material-ui/core';

interface LoadingProps {
  inline?: boolean;
}

function Loading({ inline = false }: LoadingProps) {
  return (
    <Box
      height={inline ? 'auto' : '100vh'}
      display="flex"
      alignItems="center"
      justifyContent="center"
      data-testid="loading-container"
    >
      <CircularProgress data-testid="loading-indicator" />
    </Box>
  );
}

export default Loading;
